import Navbar from "../../../components/Navbar/Navbar";
import RemitDocument from "../components/RemitDocument/RemitDocument";

export default function RemitDocumentPage() {
    return (
        <>
            <Navbar />
            <RemitDocument />
        </>
    );
}
